import { Component, Inject } from '@angular/core';
import { Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AuthProvider } from './services/auth.provider';
import { AxeptioService } from './services/axeptio.service';
import { FacebookPixelService } from './services/facebook-pixel.service';
import { Logout } from './services/logout.provider';
import { Mixpanel } from './services/mixpanel.provider';
import { Multitenant } from './services/multitenant.provider';
// import { Munchkin } from './services/munchkin.provider';
import { StorageProvider } from './services/storage.provider';
import { PopUpService } from './shared/components/pop-up/pop-up.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { UrlService } from './services/url.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  public themeClass: string;
  public previousUrl: string = null;
  public currentUrl: string = null;

  constructor(
    platform: Platform,
    private multiTenant: Multitenant,
    private logOut: Logout,
    public storage: StorageProvider,
    private mixpanel: Mixpanel,
    // munchkin: Munchkin,
    private translate: TranslateService,
    private popUpService: PopUpService,
    private auth: AuthProvider,
    private facebookPixel: FacebookPixelService,
    private axeptio: AxeptioService,
    private router: Router,
    private urlService: UrlService,
    @Inject(DOCUMENT) private document: Document
  ) {

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.previousUrl = this.currentUrl;
      this.currentUrl = event.url;
      this.urlService.setPreviousUrl(this.previousUrl);
      this.createCanonicalLik();
    });

    this.themeClass = this.multiTenant.getDomainClass();
    window.onbeforeunload = (e) => {
      const currentDate = new Date();
      const leaveTime = currentDate.toString();
      storage.setStorage('leave_time', leaveTime);
      storage.removeStorage('hybridApp');
    };

    const date = new Date();
    let storedLeaveTime: string;
    if (storage.getStorage('leave_time')) {
      storedLeaveTime = storage.getStorage('leave_time');
    }

    const tenMinutesLater = new Date(storedLeaveTime);
    tenMinutesLater.setMinutes(tenMinutesLater.getMinutes() + 10);

    if (date > tenMinutesLater && this.multiTenant.getDomainClass() === 'playbacpresse') {
      this.logOut.profileLogOut();
    }

    this.mixpanel.runPixelCode(this.themeClass);
    // stopped after angular version updated
    // munchkin.munchkinStart();

    platform.ready().then(() => {
      translate.addLangs(['fr', 'ja']);
      translate.setDefaultLang('fr');

      const browserLang = translate.getBrowserLang();
      if (this.multiTenant.getDomainClass() === 'mwjp' || this.multiTenant.getDomainClass() === 'mljp') {
        translate.use('ja');
      }
      if (this.multiTenant.getDomainClass() === 'mwde' || this.multiTenant.getDomainClass() === 'mlde') {
        translate.use('de');
      }

      if (this.multiTenant.getDomainClass() === 'clfy') {
        translate.use('en');
      }
    });
  }

  private createCanonicalLik() {

    let canonical = '';
    switch (this.multiTenant.getDomainClass()) {
      case 'lepq':
        canonical = window.location.href.replace('m-lepetitquotidien', 'lepetitquotidien');
        break;
      case 'mquo':
        canonical = window.location.href.replace('m-monquotidien', 'monquotidien');
        break;
      case 'actu':
        canonical = window.location.href.replace('m-lactu', 'lactu');
        break;
      case 'aeco':
        canonical = window.location.href.replace('m-leco', 'leco');
        break;
      case 'mlwk':
        canonical = window.location.href.replace('m-mylittleweekly', 'mylittleweekly');
        break;
      case 'week':
        canonical = window.location.href.replace('m-myweekly', 'myweekly');
        break;
      case 'mlne':
        canonical = window.location.href.replace('m-mylittleweeklynews', 'mylittleweeklynews');
        break;
      case 'mwne':
        canonical = window.location.href.replace('m-myweeklynews', 'myweeklynews');
        break;
      case 'woch':
        canonical = window.location.href.replace('m-meinewoche', 'meinewoche');
        break;
      case 'mquovideo':
        canonical = window.location.href.replace('m-monquotidienvideo', 'monquotidienvideo');
        break;
      case 'actuvideo':
        canonical = window.location.href.replace('m-lactuvideo', 'lactuvideo');
        break;
      default:
        canonical = window.location.href.replace('m-digital', 'digital');
    }

    const lart = this.document.querySelector('link[rel=canonical]');
    lart.setAttribute('href',canonical);
  }
}
